import { Card } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useAlert } from "../../../../context/AlertContext";
import { AddIcon } from "../../../../data/iconImage";
import { filteredCreateNewKey } from "../../../../utils/ManageArray";
import Table from "../../../../components/Table";
import SearchFilter from "../../../../components/SearchFilter";
import ButtonOptionSubmenu from "../../../../components/ButtonOptionSubmenu";
import ButtonLink from "../../../../components/ButtonLink";
import ContractFocHdsService from "../../../../services/contractfochd.service";
import ContractFocDtsService from "../../../../services/contractfocdt.service";

export default function LumsumsTab() {
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState([]);
  const [data, setData] = useState({ Hds: [], Dts: [] });
  const searchInput = [
    {
      name: "Contract_No",
      label: "เลขที่สัญญา",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "Contract_Start_Date",
      label: "วันเริ่มสัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "date",
      disabled: true,
      findValue: { value: "Contract_No" }
    },
    {
      name: "Contract_End_Date",
      label: "วันสิ้นสุดสัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "date",
      disabled: true,
      findValue: { value: "Contract_No" }
    },
    {
      name: "Project_No",
      label: "เลขที่โครงการ",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "text",
      disabled: true,
      findValue: { value: "Contract_No" }
    },
    {
      name: "Contract_Foc_Date",
      label: "วันที่",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "date",
      readOnly: true,
      findValue: { value: "Contract_No" }
    },
    {
      name: "Customer.Cus_Code",
      label: "รหัสลูกค้าหลัก (BP Master Code)",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "text",
      disabled: true,
      findValue: { value: "Contract_No" }
    },
    {
      name: "Customer.Cus_Name",
      label: "ชื่อลูกค้า",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "text",
      size: 6,
      disabled: true,
      findValue: { value: "Contract_No" }
    },
    { name: "Customer.Cus_Code", label: "รหัสสาขา" },
    { name: "Customer.Cus_NumBranch", label: "เลขที่สาขา", size: "1_5" },
    { name: "Customer.Cus_Name", label: "ชื่อสาขา", size: "6_5" }
  ];
  const columns = [
    {
      name: "ลำดับ",
      selector: (row) => row.rowIndex,
      sortable: true,
      width: "110px"
    },
    {
      name: "รหัสสินค้า",
      selector: (row) => row.ParentItem?.Item_Code,
      sortable: true
    },
    {
      name: "รายละเอียดสินค้า",
      selector: (row) => row.ParentItem?.Item_Name_TH,
      grow: 2
    },
    {
      name: "รหัสอุปกรณ์/อะไหล่",
      selector: (row) => row.ChildItem?.Item_Code,
      sortable: true
    },
    {
      name: "ชื่ออุปกรณ์/อะไหล่",
      selector: (row) => row.ChildItem?.Item_Name_TH,
      grow: 2
    },
    {
      name: "ชื่อเหตุผลสำหรับ FOC",
      selector: (row) => row.Foc_Reason_Name
    },
    { name: "รายละเอียด FOC", selector: (row) => row.Foc_Des, width: "200px" },
    {
      name: "",
      selector: (row) => (
        <ButtonOptionSubmenu
          data={row}
          editButton
          deleteButton
          state={{ edit: { name: "lumsum", data: row, search: searchInput } }}
          onDeleteCallback={handleSubmitDelete}
        />
      ),
      right: true,
      width: "180px"
    }
  ];

  const getAllContractFocHds = () => {
    setLoading(true);
    ContractFocHdsService.getAllContractFocHds()
      .then((response) => setData((prev) => ({ ...prev, Hds: response })))
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  const getAllContractFocDts = () => {
    setLoading(true);
    ContractFocDtsService.getAllContractFocDts()
      .then((response) => setData((prev) => ({ ...prev, Dts: response })))
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  const handleSubmitDelete = (event, { Id }) => {
    event.preventDefault();

    if (Id) {
      setLoading(true);
      ContractFocDtsService.deleteContractFocDts(Id, false)
        .then((_) => {
          showAlert({ error: "ดำเนินการสำเร็จ", type: "success" });
          getAllContractFocDts();
        })
        .catch(({ error, message }) =>
          showAlert({ error, message, type: "danger" })
        )
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    getAllContractFocHds();
    getAllContractFocDts();
  }, []);

  return (
    <>
      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Body>
          <SearchFilter
            data={data.Hds}
            inputField={searchInput}
            fieldClassName={{
              inputRow: "justify-content-end align-items-center",
              actionButton: "mt-3 text-end"
            }}
            searchCallback={(search) =>
              setSearchValue(
                search?.length && search.some(({ value }) => value)
                  ? filteredCreateNewKey({
                      data: data.Hds,
                      search,
                      newName: "Contract_Foc_Hd_Id",
                      newValue: "Id"
                    })
                  : []
              )
            }
          />
        </Card.Body>
      </Card>

      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
          <Card.Title className="mb-0 fs-2">
            กำหนดอะไหล่ในสัญญา LUMSUM
          </Card.Title>
          <ButtonLink
            linkTo="create"
            stateData={{ name: "lumsum", search: searchInput }}
            buttonName="เพิ่มข้อมูล"
            buttonClass="me-2 px-4 py-2 text-dark rounded-pill"
            iconSrc={AddIcon}
            iconName="Add Icon"
            iconClass="me-2 mb-1"
          />
        </Card.Header>

        <Card.Body>
          <Table
            data={data.Dts}
            column={columns}
            searchFilter={searchValue}
            pending={loading}
            pagination
          />
        </Card.Body>
      </Card>
    </>
  );
}
